import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { AbaOperacaoScrComponent } from "./aba-operacao-scr.component";


@NgModule({
    declarations:[
        AbaOperacaoScrComponent
    ],
    imports:[
        SharedModule
    ],
    exports:[
        AbaOperacaoScrComponent,
    ]
})
export class AbaOperacaoScrModule {}